/**
 * Strip a surrounding markdown code fence from a model reply. Strict structured outputs are
 * valid JSON, but some routed models (e.g. grok via model-router) still wrap them in a ```json
 * fence — unwrap before JSON.parse. Tolerates null/whitespace.
 */
export function unfenceJson(text: string | undefined | null): string {
  return (text ?? '').trim().replace(/^```(?:json)?\s*/i, '').replace(/\s*```$/, '');
}
